import type { GrowthBook } from '@growthbook/growthbook';

/**
 * Maps onboarding focus-area selection to an app-web landing path.
 * Keep in sync with app-web-7 `painpoint-landing.util.ts`.
 */

/** GrowthBook boolean feature — when on, post-onboarding redirect includes a painpoint landing path. */
export const PAINPOINT_LANDING_REDIRECT_FEATURE_KEY = 'painpoint-landing-redirect';

/** Refreshes GrowthBook and returns whether painpoint landing redirect is enabled. */
export async function isPainpointLandingRedirectEnabled(
  growthBook?: GrowthBook | null,
): Promise<boolean> {
  if (!growthBook?.getFeatureValue) {
    return false;
  }

  try {
    await growthBook.loadFeatures?.({ timeout: 3000 });
  } catch {
    // Fall back to the last known feature definitions.
  }

  return growthBook.getFeatureValue(PAINPOINT_LANDING_REDIRECT_FEATURE_KEY, false) === true;
}

const PAINPOINT_LANDING_PATHS: Record<string, string> = {
  accountability: '/activity-summary',
  accountabilityfocus: '/activity-summary',
  productivity: '/dashboard',
  productivityperformance: '/dashboard',
  timetrackingattendance: '/hours-tracked',
  timeattendance: '/hours-tracked',
  payroll: '/projects-report',
  payrollbilling: '/projects-report',
  aiproductivityinsights: '/benchmarks',
  softwarecost: '/software-cost-insights',
  softwarecostutilization: '/software-cost-insights',
};

function normalizePainpoint(value: string): string {
  return value.toLowerCase().replace(/[^a-z0-9]/g, '');
}

export function resolvePainpointLandingPath(painpoint: string | null | undefined): string | null {
  if (!painpoint?.trim()) {
    return null;
  }

  return PAINPOINT_LANDING_PATHS[normalizePainpoint(painpoint)] ?? null;
}
